var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.2C0 31.293 0 17.34 8.67 8.67 17.34 0 31.293 0 59.2 0h29.6c27.907 0 41.861 0 50.53 8.67C148 17.34 148 31.293 148 59.2v29.6c0 27.907 0 41.861-8.67 50.53C130.661 148 116.707 148 88.8 148H59.2c-27.907 0-41.86 0-50.53-8.67C0 130.661 0 116.707 0 88.8V59.2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.2C0 31.293 0 17.34 8.67 8.67 17.34 0 31.293 0 59.2 0h29.6c27.907 0 41.861 0 50.53 8.67C148 17.34 148 31.293 148 59.2v29.6c0 27.907 0 41.861-8.67 50.53C130.661 148 116.707 148 88.8 148H59.2c-27.907 0-41.86 0-50.53-8.67C0 130.661 0 116.707 0 88.8V59.2z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m46.21 79.025 9.882 27.351s1.235 2.559 2.558 2.559c1.323 0 20.999-20.47 20.999-20.47l21.881-42.262-54.967 25.762-.353 7.06z",
    fill: "#C8DAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m59.313 86.047-1.897 20.16s-.794 6.177 5.382 0 12.087-10.94 12.087-10.94",
    fill: "#A9C6D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.389 80.012 26.062 73.39s-2.43-.985-1.647-3.22c.161-.46.486-.853 1.457-1.527 4.504-3.14 83.363-31.483 83.363-31.483s2.226-.75 3.54-.251a1.92 1.92 0 0 1 1.308 1.426c.142.587.201 1.19.176 1.794-.006.522-.069 1.006-.117 1.764-.48 7.75-14.853 65.586-14.853 65.586s-.86 3.384-3.941 3.5a5.656 5.656 0 0 1-4.112-1.591c-6.047-5.201-26.944-19.245-31.561-22.333a.882.882 0 0 1-.38-.625c-.064-.326.29-.729.29-.729s36.387-32.344 37.356-35.739c.075-.263-.208-.393-.589-.278-2.417.89-44.312 27.347-48.936 30.267-.333.1-.685.122-1.027.062z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 74,
    y1: 148,
    x2: 74,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a756358df17ccf442fad2221ed50096d.svg";
export { ForwardRef as ReactComponent };